// src/app/Auth/utils/authStorage.js

const AUTH_USER_KEY = "auth_user";

export function setAuthUser(user) {
  localStorage.setItem(AUTH_USER_KEY, JSON.stringify(user));
}

export function getAuthUser() {
  try {
    const raw = localStorage.getItem(AUTH_USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearAuthUser() {
  localStorage.removeItem(AUTH_USER_KEY);
}

export function isAuthenticated() {
  const user = getAuthUser();
  return !!user?.email;
}

export function getUserRole() {
  const user = getAuthUser();
  return user?.role || "";
}